import type { IconData } from '@stacksjs/iconify-core'

export const deepfakeTechnology1Remix: IconData = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M20.808 3.75a2 2 0 0 1 2-2c10.224 0 18.61 7.867 19.434 17.88l3.844 5.69c.992 1.469 1.008 3.828-.92 5.074a13.8 13.8 0 0 1-3.252 1.521l-.457 5.42a5 5 0 0 1-5.814 4.512l-2.335-.394v2.797a2 2 0 1 1-4 0v-5.163a2 2 0 0 1 2.333-1.972l4.668.787A1 1 0 0 0 37.47 37l.574-6.812a2 2 0 0 1 1.555-1.784c1.31-.294 2.296-.73 2.985-1.12l-3.96-5.861a2 2 0 0 1-.339-1.013c-.4-7.5-6.134-13.586-13.478-14.532V44.25a2 2 0 1 1-4 0V34.5h-2.98l-3.562 3.563a4.5 4.5 0 1 1-2.828-2.828l4.148-4.15A2 2 0 0 1 17 30.5h3.808v-5H9.784a4.5 4.5 0 1 1 0-4h11.024v-4H18a2 2 0 0 1-1.414-.586l-4.149-4.148a4.5 4.5 0 1 1 2.828-2.828l3.563 3.562h1.98z\" clip-rule=\"evenodd\"/>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default deepfakeTechnology1Remix
